import { useQuery, useMutation } from '@tanstack/react-query';

import { openapiClient } from '@/lib/openapi-fetch';
import { settingsKeys } from './keys';

type UserId = 'self' | number;

export const useGetApiKeys = (userId: UserId) =>
  useQuery({
    queryKey: settingsKeys.apiKeys(userId),
    queryFn: async () => {
      const res = await openapiClient.GET('/users/{user_id}/apikeys', {
        params: { path: { user_id: userId } },
      });
      if (res.error) throw new Error(JSON.stringify(res.error));
      return res.data!;
    },
  });

export const useCreateApiKey = (userId: UserId) =>
  useMutation({
    mutationFn: async (body: { name: string }) => {
      const res = await openapiClient.POST('/users/{user_id}/apikeys', {
        params: { path: { user_id: userId } },
        body,
      });
      if (res.error) throw new Error(JSON.stringify(res.error));
      return res.data!;
    },
  });

export const useDeleteApiKey = (userId: UserId) =>
  useMutation({
    mutationFn: async (keyId: number) => {
      const res = await openapiClient.DELETE('/users/{user_id}/apikeys/{key_id}', {
        params: { path: { user_id: userId, key_id: keyId } },
      });
      if (res.error) throw new Error(JSON.stringify(res.error));
      return res.data;
    },
  });

export const usePatchApiKey = (userId: UserId) =>
  useMutation({
    mutationFn: async ({ keyId, name }: { keyId: number; name: string }) => {
      const res = await openapiClient.PATCH('/users/{user_id}/apikeys/{key_id}', {
        params: { path: { user_id: userId, key_id: keyId } },
        body: { name },
      });
      if (res.error) throw new Error(JSON.stringify(res.error));
      return res.data!;
    },
  });
